import ScheduleSendDetailsModel from "../../ScheduleSendDetails.model";
import IScheduleSendDetails from "../../interfaces/ScheduleSendDetails.interface";

export interface IReviewAndPayWhenToSendStepModel {
    sendLater: boolean;
    scheduleSendDetails: IScheduleSendDetails;
}

export class ReviewAndPayWhenToSendStepModel implements IReviewAndPayWhenToSendStepModel {
    sendLater: boolean;
    scheduleSendDetails: IScheduleSendDetails;

    constructor() {
        this.sendLater = false;
        this.scheduleSendDetails = new ScheduleSendDetailsModel();
    }

    static isValid(model: IReviewAndPayWhenToSendStepModel): boolean {
        if (model.sendLater && !ScheduleSendDetailsModel.validateModel(model.scheduleSendDetails)) {
            return false;
        }

        return true;
    }
}